import * as React from "react";
import styled from "styled-components";
import { Color } from "@glossy";

const Pill = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  height: 24px;
  margin: 12px 16px;
  border-radius: 12px;
  font-size: 12px;
  color: ${Color.White};
  font-style: italic;
  text-align: center;
  line-height: 24px;
`;

interface IProps {
  label: string;
  color: string;
}

const NavigationSwitcher = ({ label, color }: IProps) => {
  return <Pill color={color}>{label}</Pill>;
};

export default NavigationSwitcher;
